import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import CustomForm from '../../../core/components/core/Util/Form/CustomForm/CustomForm';
import CustomFormContainer from '../../../core/components/core/Util/Form/CustomForm/CustomFormContainer';
import config from '../../config/config';
import Fetch from '../../../core/util/core/Fetch';
import { chooseProfileFilter } from '../../helpers/chooseProfileFilter';

function Form() {
    const [formContent, setFormContent] = useState(<>Carregando...</>);

    const profileFilter = chooseProfileFilter();

    const { id } = useParams();

    const path = '/governanceroom/observatorygrouporder/';
    const endpointBackend = config.endpoints.backend;
    const paths = {
        endpointSave: endpointBackend + 'governanceroom/observatorygrouporder/save',
        endpointGetById: endpointBackend + 'governanceroom/observatorygrouporder/getById',
        endpointGetAllObservatories: endpointBackend + 'governanceroom/observatories/getall',
        endpointGetAllGroups: endpointBackend + 'governanceroom/observatorygroups/getall',
        urlGoBack: path + 'list',
        pathView: path + 'view'
    }

    const labels = {
        labelTitleAdd: "Nova Ordem de Grupos do Observatório",
        labelTitleEdit: "Editar Ordem de Grupos do Observatório",
        labelTitleView: 'Visualizar Ordem de Grupos do Observatório'
    }

    const getForm = (values) => {
        let form = {
            validateOnChange: true,
            fields: [
                {
                    name: 'governance_room_observatory_id',
                    type: 'select',
                    label: 'Observatório',
                    options: [],
                    optionsEndpoint: {
                        endpoint: paths.endpointGetAllObservatories,
                        label: 'client_observatory',
                        value: 'id',
                        params: {
                            filter: {
                                ...profileFilter
                            }
                        }
                    },
                    validations: {
                        required: true
                    },
                    columnSize: 12
                },
                {
                    name: 'groups_order',
                    type: 'multiinput',
                    label: 'Ordem dos Grupos',
                    sortBy: 'order',
                    showDeleteButton: true,
                    form: [
                        {
                            name: 'governance_room_observatory_group_id',
                            type: 'select',
                            label: 'Grupo',
                            options: [],
                            optionsEndpoint: {
                                endpoint: paths.endpointGetAllGroups,
                                label: 'name',
                                value: 'id',
                                params: {
                                    filter: {
                                        ...profileFilter
                                    }
                                }
                            },
                            validations: {
                                required: true
                            }
                        },
                        {
                            name: 'order',
                            type: 'integer',
                            label: 'Ordem',
                            maxLength: 3,
                            validations: {
                                required: true
                            },
                           styleTh: { width: '10%' }
                        }
                    ],
                    validations: {
                        required: true
                    },
                    columnSize: 12
                }
            ],
            ...paths,
            ...labels
        }
        form.values = values;
        return form;
    }

    useEffect(() => {
        const load = async () => {
            let values = {};

            if (id) {
                values = await Fetch.post(paths.endpointGetById, { id: id })
            }
            const form = getForm(values);
            setFormContent(
                <CustomFormContainer
                    form={form}
                    content={<CustomForm form={form} />}
                />
            )
        }
        load();
    }, [])

    return (
        <div>
            {formContent}
        </div>
    );
}
export default Form;
